import { FC, useState } from 'react';
import { Tabs } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { useAppSelector, useTranslate } from 'hooks';
import { selectUser } from 'selectors';

import { Paths } from 'utils/constants';

import { BearLossCalculatorModal } from '../Overview/BearLossCalculator/BearLossCalculatorModal';

import s from './index.module.scss';

export const Funding: FC = () => {
	const user = useAppSelector(selectUser);

	const navigate = useNavigate();
	const { pathname } = useLocation();

	const activeKey = pathname.includes('withdraw') ? 'withdraw' : 'deposit';

	const [isOpen, serIsOpen] = useState(!user.riskTolerance?.value);

	const { depositText, withdrawText } = useTranslate(['depositText', 'withdrawText']);

	return (
		<div className={s.funding}>
			<Tabs
				className="accountTabs"
				type="card"
				activeKey={activeKey}
				onChange={(v) =>
					navigate(v === 'withdraw' ? Paths.FUNDING_WITHDRAW : Paths.FUNDING_DEPOSIT)
				}
			>
				<Tabs.TabPane tab={depositText} key="deposit" />
				<Tabs.TabPane tab={withdrawText} key="withdraw" />
			</Tabs>

			<Outlet />

			<BearLossCalculatorModal isOpen={isOpen} onClose={() => serIsOpen(false)} />
		</div>
	);
};
